export enum ButtonId {
    USER_DETAIL = "USER_DETAIL",
    ADD_USER = "ADD_USER",
    ACTIVATE_USER = "ACTIVATE_USER",
    DEACTIVATE_USER = "DEACTIVATE_USER",
    CHANGE_PASSWORD = "CHANGE_PASSWORD",
    EXPORT_PERMISSIONS = "EXPORT_PERMISSIONS",
    IMPORT_PERMISSIONS = "IMPORT_PERMISSIONS",
}
